
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35068',
  depVersions: {
  "documents-public-ui": "static-1.35068",
  "atom": "static-1.5292",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2714",
  "client-types": "static-1.490",
  "cssUtils": "static-1.857",
  "customer-data-filters-ui": "static-1.40655",
  "customer-data-objects": "static-1.7901",
  "customer-data-property-utils": "static-1.8313",
  "documents-lib": "static-1.35073",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.356",
  "FormsCommonComponents": "static-1.86428",
  "FormUrlGenerator": "static-2.4941",
  "foundations-theming-specialty": "static-1.2384",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5811",
  "hs-test-utils": "static-1.8241",
  "hub-http": "static-1.6431",
  "hubspot-dlb": "static-2.1877",
  "HubStyle": "static-2.12004",
  "HubStyleTokens": "static-2.11697",
  "I18n": "static-7.1652",
  "icons": "static-2.671",
  "jasmine-immutable": "static-1.3240",
  "jasmine-runner": "static-1.6666",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7368",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3114",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5612",
  "quartz": "static-1.7324",
  "react": "static-7.190",
  "react-dlb": "static-1.84",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-redact-emails-from-unexpected-route-pathname.6",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5491",
  "react-virtualized": "static-2.103",
  "reference-resolvers": "static-1.8399",
  "reference-resolvers-lite": "static-1.8315",
  "reporting-data": "static-1.68475",
  "reporting-reports": "static-1.68153",
  "reporting-snowflake": "static-1.57093",
  "reporting-testing-lib": "static-1.10408",
  "reporting-visualizations": "static-1.60551",
  "reselect": "static-3.8",
  "sales-content-partitioning": "static-1.9166",
  "sanitize": "static-1.4693",
  "sanitize-text": "static-1.8366",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1963",
  "signup-constants": "static-1.19441",
  "signup-ui-url-generator": "static-2.8274",
  "StyleGuideUI": "static-3.492",
  "superstore": "static-1.4973",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4971",
  "ui-addon-form-validation": "static-1.11203",
  "ui-asset-management-lib": "static-1.11307",
  "ui-images": "static-2.1219",
  "UIComponents": "static-3.8643",
  "usage-tracker": "static-1.7573",
  "usage-tracker-container": "static-1.7563",
  "usage-tracker-core": "static-1.7423",
  "viral-links-lib": "static-1.7290",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9875",
  "foundations-components": "static-1.8339",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1102",
  "quartz-core": "static-1.6543",
  "quick-fetch": "static-1.4068",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4879",
  "ui-addon-i18n": "static-1.11363",
  "ui-addon-upgrades": "static-9.18285",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4282",
  "metrics-js": "static-1.9849",
  "styled-components": "static-2.94",
  "bend-plugin-trellis-migration": "static-1.3550",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3601",
  "quartz-webpack": "static-1.3548",
  "foundations-assets": "static-1.5091",
  "foundations-theming": "static-1.4668",
  "hub-http-shared-msw-handlers": "static-1.10479",
  "hubspotter-http": "static-1.4800",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7466",
  "crm-message-bus": "static-1.43576",
  "customer-data-filters-ui-msw-helpers": "static-1.23090",
  "customer-data-objects-ui-components": "static-1.13247",
  "customer-data-reference-ui-components": "static-1.13395",
  "customer-data-ui-utilities": "static-1.10043",
  "events-data-lib": "static-1.458",
  "framework-builder-read-service-client": "static-1.4157",
  "framework-data-schema-quick-fetch": "static-1.7015",
  "framework-data-schema-resolvers": "static-1.7110",
  "immer": "static-1.94",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.3996",
  "multi-account-reference-resolvers": "static-1.1201",
  "onboarding-tours": "static-1.17000",
  "reporting-datasets-permissions-lib": "static-1.14317",
  "stylex": "static-1.37",
  "trellis-assets": "static-1.2387",
  "trellis-components": "static-1.2406",
  "trellis-theming": "static-1.1170",
  "ui-addon-teams": "static-1.21823",
  "quartz-auth": "static-1.999",
  "ui-business-units-lib": "static-1.9298",
  "usage-tracker-session-replay": "static-1.5259",
  "ai-components-ui-library": "static-1.9525",
  "ContentUtils": "static-1.68999",
  "customer-data-properties": "static-1.52353",
  "forms-ai-lib": "static-1.4651",
  "forms-utils-lib": "static-1.12977",
  "foundations-components-test-utils": "static-1.5822",
  "react-dnd-compat": "static-1.4833",
  "react-tinymce": "static-1.55821",
  "tinymce-config": "static-2.54947",
  "ui-gdpr-components": "static-1.10571",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3653",
  "HeadJS": "static-2.782",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3352",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.231",
  "ui-fonts": "static-1.959",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4536",
  "csstype": "static-1.50",
  "quartz-head": "static-1.989",
  "web-vitals": "static-1.9",
  "batch-promise": "static-1.1761",
  "external-options-client-types": "static-1.4277",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.999",
  "frontend-preferences-client": "static-1.8145",
  "graphql": "static-1.85",
  "persist-promise": "static-1.3918",
  "reporting-client-types": "static-1.2635",
  "apollo-stack-hubspot": "static-3.89",
  "growth-payments-core": "static-1.26018",
  "hubspot-apollo-client": "static-1.5094",
  "foundations-components-legacy": "static-1.1364",
  "quartz-routing": "static-1.754",
  "hs-story-utils": "static-1.9642",
  "react-flip-move": "static-1.74",
  "nested-table": "static-1.452",
  "timezone-utils": "static-2.5464",
  "seat-types-lib": "static-1.529",
  "react-create-root-preference": "static-1.52",
  "bend-plugin-foundations-components": "static-1.4608",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.860",
  "mobile-manifest-mixins": "static-1.557",
  "module-federation": "static-1.29",
  "quartz-test": "static-1.999",
  "quartz-tracking": "static-1.703",
  "bend-plugin-chirp-manifest": "static-1.289",
  "chirp-fetch": "static-1.2105",
  "merchandise-lib": "static-1.272",
  "purchase-motions-components": "static-1.6249",
  "salesImages": "static-1.530",
  "ts-schema": "static-1.4228",
  "bender-build-tools": "static-1.3344",
  "bend-plugin-foundations-theming": "static-1.3151",
  "restore-request-side-panel-lib": "static-1.1471",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.403",
  "pulse": "static-1.838",
  "conditional-properties-service-client": "static-1.3947",
  "crm-pipelines-api-client-types": "static-1.4285",
  "fdsr-migration-layer": "static-1.229",
  "multi-currency-client-types": "static-1.3841",
  "getting-started-shared-tasks": "static-1.19056",
  "growth-data-modal": "static-1.5779",
  "growth-onboarding-confetti": "static-1.3277",
  "growth-onboarding-next-action-utils": "static-1.2542",
  "navigation-components": "static-1.18669",
  "onboarding-tours-client": "static-1.5214",
  "onboarding-tours-utils": "static-1.1066",
  "ui-shepherd-react": "static-3.10478",
  "ui-shepherd-tracker": "static-1.7859",
  "ui-universal-auth": "static-1.9241",
  "user-context": "static-1.5330",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.35",
  "hubspotter-http-shared-msw-handlers": "static-1.10477",
  "magpie-lib": "static-1.5702",
  "navigation-messaging": "static-1.7996",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22478",
  "copilot-toolkit": "static-1.11692",
  "cms-field-types": "static-1.5031",
  "content-icons-ui": "static-1.2292",
  "integrations-lib": "static-1.16863",
  "calling-global-api": "static-1.65272",
  "calling-internal-common": "static-1.31532",
  "calling-lifecycle-internal": "static-1.66654",
  "calling-lifecycle-messages": "static-1.58948",
  "commerce-products-lib": "static-1.10345",
  "crm-links": "static-1.6536",
  "crm-index-visualization-core": "static-1.4429",
  "customer-data-properties-shared-msw-handlers": "static-1.9806",
  "file-manager-components": "static-1.24295",
  "formula-editor": "static-1.14635",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4365",
  "meetings-icalendar-utils-lib": "static-1.851",
  "object-builder-ui-client": "static-1.49458",
  "pipeline-validation-client-types": "static-1.4118",
  "property-value-citations": "static-1.2967",
  "smart-property-lib": "static-1.8124",
  "tiered-pricing": "static-1.1815",
  "topics-actions-lib": "static-1.375",
  "ui-addon-iframeable": "static-1.9293",
  "zustand": "static-1.79",
  "final-form": "static-1.73",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20195",
  "tinymce-themes": "static-1.56917",
  "data-token-picker": "static-1.16778",
  "hub-http-contrib": "static-1.3256",
  "interframe": "static-3.4972",
  "tinymce-data": "static-1.41032",
  "tinymce-plugins": "static-1.58061",
  "ui-addon-sales-email": "static-1.5429",
  "onboarding-scopes": "static-1.6675",
  "ui-addon-opt": "static-4.8579",
  "apollo-link-hub-http": "static-2.4874",
  "hubspot-apollo-cache": "static-1.553",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.391",
  "purchase-motions-api": "static-1.6252",
  "event-emitter": "static-1.1169",
  "bend-plugin-pulse": "static-1.341",
  "fast-json-patch": "static-1.66",
  "onboarding-data-sync-lib": "static-1.2349",
  "growth-onboarding-next-action-components": "static-1.2570",
  "user-context-client": "static-1.4754",
  "idb-keyval": "static-1.47",
  "magpie-types": "static-1.5162",
  "nest": "static-1.454",
  "reactive-lib": "static-1.937",
  "simple-logging-lib": "static-1.3265",
  "unified-auth-core-lib": "static-1.1037",
  "getting-started-shared-tasks-store": "static-1.18174",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1507",
  "integrations-error-boundary-lib": "static-1.14278",
  "integrations-tracking-lib": "static-1.5825",
  "native-integrations-shared-strings": "static-1.7994",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10582",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.755",
  "calling-error-reporting": "static-1.31539",
  "shared-worker-versioning": "static-1.11256",
  "calling-usage-tracker": "static-1.6756",
  "voice-sms-access-library": "static-1.1797",
  "customer-data-tracking": "static-1.7100",
  "commerce-permissions": "static-1.994",
  "products-iframe-lib": "static-1.8447",
  "products-ui-components-shared-msw-handlers": "static-1.10861",
  "location-customization-utils-lib": "static-1.9935",
  "crm-index-associations-lib": "static-1.6658",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10562",
  "sales-views-client-types": "static-1.4474",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4367",
  "video-components-external": "static-1.11988",
  "video-data-lib": "static-1.35646",
  "bark-lib": "static-1.16723",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6105",
  "react-codemirror": "static-1.10856",
  "data-agent-kit": "static-1.533",
  "feedback-loader": "static-1.29693",
  "fsm": "static-1.3953",
  "policy-lib": "static-1.7010",
  "react-colorpicker": "static-2.10428",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10625",
  "FileManagerLib": "static-1.39935",
  "NamespacedHubStyle": "static-2.9199",
  "FileManagerCore": "static-1.39794",
  "content-assistance-lib": "static-1.8095",
  "layout-dnd-components": "static-1.12851",
  "layout-dnd-utils": "static-1.11826",
  "ui-addon-emoji-picker": "static-1.10103",
  "ui-brand-identity-lib": "static-1.16105",
  "InboxConnectUtils": "static-4.15404",
  "meetings-connect-utils-lib": "static-1.7824",
  "breeze-engine-chat-components": "static-1.485",
  "breeze-engine-core": "static-1.785",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "universal-page-editor-lib": "static-1.3228",
  "adobe-sign-auth-lib": "static-1.298",
  "ads-unified-auth-lib": "static-1.867",
  "google-sheets-integration-lib": "static-1.877",
  "microsoft-drive-integration-lib": "static-1.1006",
  "surveymonkey-integration-lib": "static-1.321",
  "slack-ui-library": "static-1.10615",
  "calling-orchestration-schema": "static-1.36574",
  "crm-record-cards-service-types": "static-1.3734",
  "content-media-composition-data-lib": "static-1.13024",
  "content-media-compositions": "static-2.17031",
  "media-bridge-lib": "static-1.19297",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16216",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4726",
  "storybook-react": "static-1.36",
  "audio-components": "static-1.6236",
  "FileManagerImages": "static-1.37446",
  "video-components": "static-1.13990",
  "breeze-artifacts-sdk": "static-1.96",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4749",
  "video-embed": "static-1.36480",
  "ui-addon-video-player": "static-1.8922",
  "ui-coaching-tips": "static-1.29162",
  "ContentData": "static-1.69074",
  "layout-data-lib": "static-1.10151",
  "social-insights-client-types": "static-1.22638",
  "outpost": "static-1.4380",
  "growth-onboarding-feedback-components": "static-1.6799",
  "advanced-menus-core": "static-1.15477",
  "advanced-menus-lib": "static-1.12362",
  "ExportDialog": "static-6.10597",
  "ui-memberships-settings-lib": "static-1.34659",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15476",
  "simple-menus-lib": "static-1.16993"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35068",
  "atom": "/atom/static-1.5292",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2714",
  "client-types": "/client-types/static-1.490",
  "cssUtils": "/cssUtils/static-1.857",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40655",
  "customer-data-objects": "/customer-data-objects/static-1.7901",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8313",
  "documents-lib": "/documents-lib/static-1.35073",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.356",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86428",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4941",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2384",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5811",
  "hs-test-utils": "/hs-test-utils/static-1.8241",
  "hub-http": "/hub-http/static-1.6431",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "HubStyle": "/HubStyle/static-2.12004",
  "HubStyleTokens": "/HubStyleTokens/static-2.11697",
  "I18n": "/I18n/static-7.1652",
  "icons": "/icons/static-2.671",
  "jasmine-immutable": "/jasmine-immutable/static-1.3240",
  "jasmine-runner": "/jasmine-runner/static-1.6666",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7368",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3114",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5612",
  "quartz": "/quartz/static-1.7324",
  "react": "/react/static-7.190",
  "react-dlb": "/react-dlb/static-1.84",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-redact-emails-from-unexpected-route-pathname.6",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5491",
  "react-virtualized": "/react-virtualized/static-2.103",
  "reference-resolvers": "/reference-resolvers/static-1.8399",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8315",
  "reporting-data": "/reporting-data/static-1.68475",
  "reporting-reports": "/reporting-reports/static-1.68153",
  "reporting-snowflake": "/reporting-snowflake/static-1.57093",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10408",
  "reporting-visualizations": "/reporting-visualizations/static-1.60551",
  "reselect": "/reselect/static-3.8",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9166",
  "sanitize": "/sanitize/static-1.4693",
  "sanitize-text": "/sanitize-text/static-1.8366",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1963",
  "signup-constants": "/signup-constants/static-1.19441",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8274",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "superstore": "/superstore/static-1.4973",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4971",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11203",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11307",
  "ui-images": "/ui-images/static-2.1219",
  "UIComponents": "/UIComponents/static-3.8643",
  "usage-tracker": "/usage-tracker/static-1.7573",
  "usage-tracker-container": "/usage-tracker-container/static-1.7563",
  "usage-tracker-core": "/usage-tracker-core/static-1.7423",
  "viral-links-lib": "/viral-links-lib/static-1.7290",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9875",
  "foundations-components": "/foundations-components/static-1.8339",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1102",
  "quartz-core": "/quartz-core/static-1.6543",
  "quick-fetch": "/quick-fetch/static-1.4068",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4879",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11363",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18285",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "metrics-js": "/metrics-js/static-1.9849",
  "styled-components": "/styled-components/static-2.94",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3550",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3601",
  "quartz-webpack": "/quartz-webpack/static-1.3548",
  "foundations-assets": "/foundations-assets/static-1.5091",
  "foundations-theming": "/foundations-theming/static-1.4668",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10479",
  "hubspotter-http": "/hubspotter-http/static-1.4800",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7466",
  "crm-message-bus": "/crm-message-bus/static-1.43576",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23090",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13247",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13395",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10043",
  "events-data-lib": "/events-data-lib/static-1.458",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4157",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7015",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7110",
  "immer": "/immer/static-1.94",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3996",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1201",
  "onboarding-tours": "/onboarding-tours/static-1.17000",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14317",
  "stylex": "/stylex/static-1.37",
  "trellis-assets": "/trellis-assets/static-1.2387",
  "trellis-components": "/trellis-components/static-1.2406",
  "trellis-theming": "/trellis-theming/static-1.1170",
  "ui-addon-teams": "/ui-addon-teams/static-1.21823",
  "quartz-auth": "/quartz-auth/static-1.999",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9298",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5259",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9525",
  "ContentUtils": "/ContentUtils/static-1.68999",
  "customer-data-properties": "/customer-data-properties/static-1.52353",
  "forms-ai-lib": "/forms-ai-lib/static-1.4651",
  "forms-utils-lib": "/forms-utils-lib/static-1.12977",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5822",
  "react-dnd-compat": "/react-dnd-compat/static-1.4833",
  "react-tinymce": "/react-tinymce/static-1.55821",
  "tinymce-config": "/tinymce-config/static-2.54947",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10571",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3653",
  "HeadJS": "/HeadJS/static-2.782",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3352",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.231",
  "ui-fonts": "/ui-fonts/static-1.959",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4536",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.989",
  "web-vitals": "/web-vitals/static-1.9",
  "batch-promise": "/batch-promise/static-1.1761",
  "external-options-client-types": "/external-options-client-types/static-1.4277",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.999",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8145",
  "graphql": "/graphql/static-1.85",
  "persist-promise": "/persist-promise/static-1.3918",
  "reporting-client-types": "/reporting-client-types/static-1.2635",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "growth-payments-core": "/growth-payments-core/static-1.26018",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5094",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1364",
  "quartz-routing": "/quartz-routing/static-1.754",
  "hs-story-utils": "/hs-story-utils/static-1.9642",
  "react-flip-move": "/react-flip-move/static-1.74",
  "nested-table": "/nested-table/static-1.452",
  "timezone-utils": "/timezone-utils/static-2.5464",
  "seat-types-lib": "/seat-types-lib/static-1.529",
  "react-create-root-preference": "/react-create-root-preference/static-1.52",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4608",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.860",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.557",
  "module-federation": "/module-federation/static-1.29",
  "quartz-test": "/quartz-test/static-1.999",
  "quartz-tracking": "/quartz-tracking/static-1.703",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.289",
  "chirp-fetch": "/chirp-fetch/static-1.2105",
  "merchandise-lib": "/merchandise-lib/static-1.272",
  "purchase-motions-components": "/purchase-motions-components/static-1.6249",
  "salesImages": "/salesImages/static-1.530",
  "ts-schema": "/ts-schema/static-1.4228",
  "bender-build-tools": "/bender-build-tools/static-1.3344",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3151",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1471",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.403",
  "pulse": "/pulse/static-1.838",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3947",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4285",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.229",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3841",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19056",
  "growth-data-modal": "/growth-data-modal/static-1.5779",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3277",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2542",
  "navigation-components": "/navigation-components/static-1.18669",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5214",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1066",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10478",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7859",
  "ui-universal-auth": "/ui-universal-auth/static-1.9241",
  "user-context": "/user-context/static-1.5330",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10477",
  "magpie-lib": "/magpie-lib/static-1.5702",
  "navigation-messaging": "/navigation-messaging/static-1.7996",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22478",
  "copilot-toolkit": "/copilot-toolkit/static-1.11692",
  "cms-field-types": "/cms-field-types/static-1.5031",
  "content-icons-ui": "/content-icons-ui/static-1.2292",
  "integrations-lib": "/integrations-lib/static-1.16863",
  "calling-global-api": "/calling-global-api/static-1.65272",
  "calling-internal-common": "/calling-internal-common/static-1.31532",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66654",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58948",
  "commerce-products-lib": "/commerce-products-lib/static-1.10345",
  "crm-links": "/crm-links/static-1.6536",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4429",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9806",
  "file-manager-components": "/file-manager-components/static-1.24295",
  "formula-editor": "/formula-editor/static-1.14635",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4365",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.851",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49458",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4118",
  "property-value-citations": "/property-value-citations/static-1.2967",
  "smart-property-lib": "/smart-property-lib/static-1.8124",
  "tiered-pricing": "/tiered-pricing/static-1.1815",
  "topics-actions-lib": "/topics-actions-lib/static-1.375",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9293",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.73",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20195",
  "tinymce-themes": "/tinymce-themes/static-1.56917",
  "data-token-picker": "/data-token-picker/static-1.16778",
  "hub-http-contrib": "/hub-http-contrib/static-1.3256",
  "interframe": "/interframe/static-3.4972",
  "tinymce-data": "/tinymce-data/static-1.41032",
  "tinymce-plugins": "/tinymce-plugins/static-1.58061",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5429",
  "onboarding-scopes": "/onboarding-scopes/static-1.6675",
  "ui-addon-opt": "/ui-addon-opt/static-4.8579",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4874",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.553",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.391",
  "purchase-motions-api": "/purchase-motions-api/static-1.6252",
  "event-emitter": "/event-emitter/static-1.1169",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.341",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2349",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2570",
  "user-context-client": "/user-context-client/static-1.4754",
  "idb-keyval": "/idb-keyval/static-1.47",
  "magpie-types": "/magpie-types/static-1.5162",
  "nest": "/nest/static-1.454",
  "reactive-lib": "/reactive-lib/static-1.937",
  "simple-logging-lib": "/simple-logging-lib/static-1.3265",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1037",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18174",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1507",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14278",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5825",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7994",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10582",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.755",
  "calling-error-reporting": "/calling-error-reporting/static-1.31539",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11256",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6756",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1797",
  "customer-data-tracking": "/customer-data-tracking/static-1.7100",
  "commerce-permissions": "/commerce-permissions/static-1.994",
  "products-iframe-lib": "/products-iframe-lib/static-1.8447",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10861",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9935",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6658",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10562",
  "sales-views-client-types": "/sales-views-client-types/static-1.4474",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4367",
  "video-components-external": "/video-components-external/static-1.11988",
  "video-data-lib": "/video-data-lib/static-1.35646",
  "bark-lib": "/bark-lib/static-1.16723",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6105",
  "react-codemirror": "/react-codemirror/static-1.10856",
  "data-agent-kit": "/data-agent-kit/static-1.533",
  "feedback-loader": "/feedback-loader/static-1.29693",
  "fsm": "/fsm/static-1.3953",
  "policy-lib": "/policy-lib/static-1.7010",
  "react-colorpicker": "/react-colorpicker/static-2.10428",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10625",
  "FileManagerLib": "/FileManagerLib/static-1.39935",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9199",
  "FileManagerCore": "/FileManagerCore/static-1.39794",
  "content-assistance-lib": "/content-assistance-lib/static-1.8095",
  "layout-dnd-components": "/layout-dnd-components/static-1.12851",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11826",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10103",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16105",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15404",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7824",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.485",
  "breeze-engine-core": "/breeze-engine-core/static-1.785",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3228",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.298",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.867",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.877",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1006",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.321",
  "slack-ui-library": "/slack-ui-library/static-1.10615",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36574",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3734",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13024",
  "content-media-compositions": "/content-media-compositions/static-2.17031",
  "media-bridge-lib": "/media-bridge-lib/static-1.19297",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16216",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4726",
  "storybook-react": "/storybook-react/static-1.36",
  "audio-components": "/audio-components/static-1.6236",
  "FileManagerImages": "/FileManagerImages/static-1.37446",
  "video-components": "/video-components/static-1.13990",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.96",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4749",
  "video-embed": "/video-embed/static-1.36480",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8922",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29162",
  "ContentData": "/ContentData/static-1.69074",
  "layout-data-lib": "/layout-data-lib/static-1.10151",
  "social-insights-client-types": "/social-insights-client-types/static-1.22638",
  "outpost": "/outpost/static-1.4380",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6799",
  "advanced-menus-core": "/advanced-menus-core/static-1.15477",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12362",
  "ExportDialog": "/ExportDialog/static-6.10597",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34659",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15476",
  "simple-menus-lib": "/simple-menus-lib/static-1.16993"
}
};
